(function () {
  var STORAGE_KEY = 'eros_commerce_session_v1';
  var listeners = [];

  function safeParse(raw) {
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function read() {
    try {
      return safeParse(window.localStorage.getItem(STORAGE_KEY));
    } catch (e) {
      // Safari private mode / storage disabled — treat as signed out.
      return null;
    }
  }

  function write(session) {
    try {
      if (session) {
        // httpOnly-cookie migration: the JWT must never be stored in
        // JS-readable storage (that was the whole XSS exposure). Persist a
        // shallow copy with `token` stripped — only non-secret fields
        // (customerGid, e164, ...) live here. Auth travels solely via the
        // first-party HttpOnly `eros_session` cookie now.
        var persisted = Object.assign({}, session);
        delete persisted.token;
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(persisted));
      } else {
        window.localStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) {
      // Ignore — session just won't persist across reloads in this browser mode.
    }
  }

  function notify() {
    var current = read();
    for (var i = 0; i < listeners.length; i++) {
      try {
        listeners[i](current);
      } catch (e) {
        // A broken listener must not break the others.
      }
    }
  }

  var ErosSession = {
    /**
     * Returns { customerGid, e164 } or null when signed out. The JWT now
     * lives only in the HttpOnly `eros_session` cookie, never in
     * JS-readable storage.
     */
    get: function () {
      return read();
    },
    set: function (session) {
      write(session);
      notify();
    },
    clear: function () {
      write(null);
      notify();
    },
    isSignedIn: function () {
      var s = read();
      return !!(s && s.customerGid);
    },
    /** fn(session|null) is called immediately with the current state, then again on every change. */
    onChange: function (fn) {
      listeners.push(fn);
      fn(read());
      return function unsubscribe() {
        var idx = listeners.indexOf(fn);
        if (idx !== -1) listeners.splice(idx, 1);
      };
    },
  };

  // Cross-tab sync: another tab signing in/out should update this tab too.
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) notify();
  });

  window.ErosSession = ErosSession;
})();
